import { Component, Input } from '@angular/core';
import {
	SiteAmenityModel,
	SiteAmenitiesList,
	SiteAmenityTypes
} from '../../models/SiteDetails/SiteAmenityModel';

@Component({
	selector: 'app-site-amenities-widget',
	templateUrl: './site-amenities-widget.component.html',
	styleUrls: ['./site-amenities-widget.component.scss'],
})
export class SiteAmenitiesWidgetComponent {
	@Input() amenities: SiteAmenityModel[] = SiteAmenitiesList;
	private step = 2;

	get count() {
		return this.amenities.length;
	}

	get amenitiesMatrix()
	{
		const list = [];
		const numRows = Math.ceil(this.amenities?.length / this.step);
		for(let i = 0; i < numRows; ++i)
		{
			list.push(this.amenities?.slice(i * this.step, i * this.step + this.step));
		}
		return list;
	}
}
